import { api } from '@/lib/api';
import type { SeoAutopilotSettings, SeoAutopilotStatus } from '@/data/seo-autopilot-model';

/** GET /v1/content/seo-autopilot — settings, stops, listings, alerts, audit, cost estimate. */
export async function getSeoAutopilot(): Promise<SeoAutopilotStatus> {
  return api.get<SeoAutopilotStatus>('/content/seo-autopilot');
}

/** POST /v1/content/seo-autopilot/settings — server validates, saves and audits. */
export async function saveSeoAutopilotSettings(settings: Partial<SeoAutopilotSettings>): Promise<SeoAutopilotStatus & { saved: boolean }> {
  return api.post<SeoAutopilotStatus & { saved: boolean }>('/content/seo-autopilot/settings', { settings });
}

/** POST /v1/content/seo-autopilot/resume — owner clears an auto-pause (server validates + audits). */
export async function resumeSeoAutopilotListing(listingId: string): Promise<SeoAutopilotStatus & { resumed: string }> {
  return api.post<SeoAutopilotStatus & { resumed: string }>('/content/seo-autopilot/resume', { listing_id: listingId });
}
